import React from 'react';
import {ReactComponent as EditIcon} from '../../../../../../assets/main/groups/main-top/edit.svg';
import {useAppSelector} from "common/hook";
import {NavLink, useParams} from "react-router-dom";
import {ROLE_TEACHER} from "entities/constants/constants";

export const OnlineEdit = () => {
    const roleType = useAppSelector((state) => state.role.roleType);
    const lessonsId = useAppSelector(state => state.lessons.items[0]?.id);
    const { groupId } = useParams();
    return (
        <NavLink className='no-hover' to={`/groups/${groupId}/edit-lesson/${lessonsId}`}>
            {roleType === ROLE_TEACHER &&
                <span className="edit-lesson-btn p-icon pointer-elem control-btn">
                     <span className="text">Редактировать занятие</span>
                     <span className="icon"><EditIcon/></span>
            </span>
            }
        </NavLink>
    );
};
